import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { CdkMenuModule } from '@angular/cdk/menu';
import { ISSelectModule } from '../is-select/is-select.module';
import { ISDialogModule } from '../is-dialog/is-dialog.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { ISDateTimePickerModule } from '../is-date-time-picker/is-date-time-picker.module';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { OverlayModule } from '@angular/cdk/overlay';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SharedModule } from '../shared.module';
import { ISMultiSelectModule } from "../is-multi-select/is-multi-select.module";
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatChipsModule } from '@angular/material/chips';
import { TableSettingsComponent } from './table-settings/table-settings.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSliderModule } from '@angular/material/slider';
import { ISFiltersModule } from '../is-filters/is-filters.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { ISChipSetModule } from '../is-chipset/is-chipset.module';
import { MVTableComponent } from './mv-table.component';
import { MvTooltipOverflowDirective } from './mv-tooltip-overflow.directive';

const materialModules = [
    MatIconModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatInputModule,
    CdkMenuModule,
    MatMenuModule,
    RouterModule,
    OverlayModule,
    DragDropModule,
    MatTooltipModule,
    MatChipsModule,
    MatSliderModule,
    MatExpansionModule
];

const isModules = [
    ISSelectModule,
    ISDateTimePickerModule,
    ISDialogModule,
    ISMultiSelectModule,
    ISFiltersModule,
    ISChipSetModule
];

@NgModule({
    declarations: [MVTableComponent, TableSettingsComponent, MvTooltipOverflowDirective],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        SharedModule,
        MatDialogModule,
        FormsModule,
        ...materialModules,
        ...isModules
    ],
    exports: [MVTableComponent]
})
export class MVTableModule { }